module.exports = __webpack_public_path__ + "static/lake_erosion_inprogress-e1ac6c60da6c5f2b778f3e63d33d769d.jpg";